import { serialize } from 'object-to-formdata'
import {
  RecruitingStatus,
  SpotworkJob,
  SpotworkJobDetail,
  SpotworkJobParams,
  SpotworkJobPayload,
} from 'types/spotwork_job'
import axiosForGigbaseBiz from '../config'
import { DataResponse } from '../response'
import { mergeURL } from './lib'
const resource = 'spotwork_jobs'

export const requests = {
  fetchIndex: async (params?: SpotworkJobParams) => {
    return await axiosForGigbaseBiz.get<DataResponse<SpotworkJob[]>>(resource, {
      params,
    })
  },
  fetchDetail: async (id: string) => {
    return await axiosForGigbaseBiz.get<DataResponse<SpotworkJobDetail>>(
      mergeURL(resource, id.toString()),
    )
  },
  create: async (params: SpotworkJobPayload) => {
    return await axiosForGigbaseBiz.post<DataResponse<SpotworkJobDetail>>(
      resource,
      serialize(params),
    )
  },
  update: async (params: {
    id: number
    recruiting_status: RecruitingStatus
  }) => {
    return await axiosForGigbaseBiz.patch<DataResponse<SpotworkJobDetail>>(
      mergeURL(resource, params.id.toString()),
      params,
    )
  },
}
